export const data = [
    {
        title: 'Основные направления научной работы кафедры',
        list: [
            `Разработка эффективных 
    технологических процессов и оборудования при производстве литья.`,
            `Разработка научных основ формирования твердой фазы в последовательных стадиях кристаллизации сталей и сплавов.`,
            `Исследование свойств литейных форм при литье по газифицируемым моделям.`,
            `Разработка матричных сплавов для получения композиционных материалов пропиткой углеграфитовых каркасов.`,
            `Исследование и разработка составов смесей и противопригарных покрытий для 
    прогрессивных процессов изготовления форм и стержней.`,
            `Разработка теоретических основ и технологий производства
    биметаллических и поверхностно-легированных отливок.`,
            `Оптимизация химических составов и свойств сталей и чугунов для конкретных условий производства и эксплуатации.`,
            `Разработка и внедрение новых, высокоэффективных материалов, позволяющих повышать свойства отливок при снижении их себестоимости.`,
            `Разработка направлений по устранению дефектности и брака отливок из различных сплавов.`,
        ],
    },
]
